export const GROUPS_VIEW_STEP = {
  DASHBOARD: 'dashboard',
  LANDING: 'landing',
  SELECT_MEMBER: 'selectMember',
  PHONE_INPUT: 'phoneInput',
  OTP: 'otp',
} as const;

export type GroupsViewStep =
  (typeof GROUPS_VIEW_STEP)[keyof typeof GROUPS_VIEW_STEP];

export const GROUPS_DASHBOARD_STEP = {
  GENERAL: 'general',
  DETAIL: 'detail',
  ADD_EXPENSE: 'addExpense',
} as const;

export type GroupsDashboardStep =
  (typeof GROUPS_DASHBOARD_STEP)[keyof typeof GROUPS_DASHBOARD_STEP];

export const GROUPS_QUERY_PARAMS = {
  GROUP_ID: 'groupId',
  GROUP_NAME: 'groupName',
  PARTICIPANT_ID: 'participantId',
  FROM_PARTICIPANT_ID: 'fromParticipantId',
  TO_PARTICIPANT_ID: 'toParticipantId',
  INVITER_NAME: 'inviterName',
} as const;

export const GROUPS_UTM = {
  INTRO: {
    SOURCE: 'groups',
    MEDIUM: 'webapp',
    CAMPAIGN: 'groups_payment_funnel',
    CONTENT: 'group_intro',
  },
  DASHBOARD: {
    SOURCE: 'groups',
    MEDIUM: 'webapp',
    CAMPAIGN: 'groups_payment_funnel',
    CONTENT: 'group_dashboard',
  },
};

export const GROUPS_PAGES = {
  LANDING: 'landing',
  DASHBOARD: 'dashboard',
  ERROR: 'error',
  SUCCESS: 'success',
};

export const GROUPS_ROUTES = {
  ERROR: '/groups/error',
  DASHBOARD: '/groups/dashboard',
  SUCCESS: '/groups/success',
  LANDING: '/groups',
} as const;

export const NEW_PARTICIPANT_ID = 'split-user-id-not-listed';

export const SEGMENT_CONTROLS = [
  {id: 'group-balances', label: 'Balances'},
  {id: 'group-expenses', label: 'Expenses'},
];

export const GROUPS_DASHBOARD_BALANCES = {
  OWED: {
    id: 'owed',
    image: '/assets/images/splits/moneyBag.webp',
    imageAlt: 'Money Bag',
  },
  OWE: {
    id: 'owe',
    image: '/assets/images/splits/flyingMoney.webp',
    imageAlt: 'Flying Money',
  },
};
